import { render, staticRenderFns } from "./StickyToast.vue?vue&type=template&id=0b635fb8&"
import script from "./StickyToast.vue?vue&type=script&lang=js&"
export * from "./StickyToast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports